<div class="footer">
  <span
    ><a href="{{ DOCS_URL }}changelog/changelog.html"
      >Version {{ buildInfo.version }}</a
    >
    -
    <a href="https://github.com/cevi/automatic_walk-time_tables"
      >Quelle auf Github</a
    ></span
  >
  <span
    >Build:
    <a
      target="_blank"
      href="https://github.com/cevi/automatic_walk-time_tables/tree/{{
        buildInfo.git.hash
      }}"
      >{{ buildInfo.git.hash }}</a
    >
    vom {{ buildDate }}</span
  >
</div>
